export default {
    SIZE: "Размер",
    COLUMN_SETTINGS: "Выбор столбцов",
    FORMAT: "ФОРМАТ",
    TABLE: "Таблица",
    CARDS: "Карточки",
    NO_SELECTION_HINT: "Выберите минимум одну строку таблицы",
    NO_NODE_SOURCES_SELECTION_HINT: "Выберите узел графа"
};
